// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amazon-container {
    font-family: Arial, sans-serif;
    line-height: 1.6;
    margin: 20px;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 8px;
    /* max-width: 900px; Centered content with max width */
}

.amazon-title-headline {
    font-size: 25px;
    font-weight: bold;
    color: #064669;
    margin-bottom: 15px;
}

.amazon-sub-title-headline {
    font-size: 20px;
    font-weight: bold;
    margin-left: 30px;
    color: #333;
}

.amazon-text {
    margin-left: 50px;
    font-size: 16px;
    color: #444;
}

.amazon-img {
    max-width: 100%;
    height: auto;
    display: block;
}

.amazon-tips {
    list-style-type: none;
    padding-left: 40px;
    font-style: italic;
}

.amazon-sub-text {
    margin-left: 60px;
    font-size: 15px;
    color: #555;
}

/* Bullet Styles */
.amazon-list {
    list-style-type: none;
    padding-left: 60px;
}

.amazon-outline-bullet {
    position: relative;
    padding-left: 44px;
    margin-bottom: 8px;
}

.amazon-outline-bullet::before {
    content: "○";
    position: absolute;
    left: 0;
    color: #064669;
    font-size: 14px;
}

.amazon-square-list {
    list-style-type: none;
    padding-left: 40px;
}

.amazon-container {
    --primary-50: #e9f2ff;
    --primary-300: #7fb7ff;
    --primary-500: #0077d6;
    --muted: #6b7280;

    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
    line-height: 1.65;
    margin: 24px;
    padding: 32px;
    background: linear-gradient(180deg, var(--primary-50), #f6fbff);
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(2,48,84,0.06);
    color: #042a48;
}
.amazon-img{
    max-width: 100%;
    height: auto;
    display:block;
    margin: 12px 0;
    border-radius: 8px;
    box-shadow: 0 8px 20px rgba(2,48,84,0.04);
}
.amazon-title-headline{
    font-size: 24px;
    font-weight: 800;
    color: var(--primary-500);
}
.amazon-sub-title-headline{
    font-size: 18px;
    font-weight: 700;
    margin-top: 12px;
}
.amazon-list{
    margin-left: 20px;
}
.amazon-outline-bullet{
    margin-left: 20px;
}
.amazon-tips{
    background: linear-gradient(90deg, rgba(3,90,166,0.06), rgba(0,119,214,0.04));
    padding: 12px;
    border-radius: 8px;
    color: var(--muted);
}
.stv-table{ width:100%; border-collapse: collapse; background: #fff; border-radius:8px; overflow:hidden; }
.stv-table th, .stv-table td{ border:1px solid #e6eefc; padding:12px; }
.tdBold{ font-weight:700; }

@media (max-width:900px){
    .amazon-container{ padding:18px; margin:12px; }
    .amazon-sub-title-headline{ font-size:16px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/pmp/amazon/amazon.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;;IAEhB,2FAA2F;IAC3F,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,+DAA+D;IAC/D,mBAAmB;IACnB,0CAA0C;IAC1C,cAAc;AAClB;AACA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yCAAyC;AAC7C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,6EAA6E;IAC7E,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA,YAAY,UAAU,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACzG,8BAA8B,wBAAwB,EAAE,YAAY,EAAE;AACtE,SAAS,eAAe,EAAE;;AAE1B;IACI,mBAAmB,YAAY,EAAE,WAAW,EAAE;IAC9C,4BAA4B,cAAc,EAAE;AAChD","sourcesContent":[".amazon-container {\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    margin: 20px;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    /* max-width: 900px; Centered content with max width */\n}\n\n.amazon-title-headline {\n    font-size: 25px;\n    font-weight: bold;\n    color: #064669;\n    margin-bottom: 15px;\n}\n\n.amazon-sub-title-headline {\n    font-size: 20px;\n    font-weight: bold;\n    margin-left: 30px;\n    color: #333;\n}\n\n.amazon-text {\n    margin-left: 50px;\n    font-size: 16px;\n    color: #444;\n}\n\n.amazon-img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n}\n\n.amazon-tips {\n    list-style-type: none;\n    padding-left: 40px;\n    font-style: italic;\n}\n\n.amazon-sub-text {\n    margin-left: 60px;\n    font-size: 15px;\n    color: #555;\n}\n\n/* Bullet Styles */\n.amazon-list {\n    list-style-type: none;\n    padding-left: 60px;\n}\n\n.amazon-outline-bullet {\n    position: relative;\n    padding-left: 44px;\n    margin-bottom: 8px;\n}\n\n.amazon-outline-bullet::before {\n    content: \"○\";\n    position: absolute;\n    left: 0;\n    color: #064669;\n    font-size: 14px;\n}\n\n.amazon-square-list {\n    list-style-type: none;\n    padding-left: 40px;\n}\n\n.amazon-container {\n    --primary-50: #e9f2ff;\n    --primary-300: #7fb7ff;\n    --primary-500: #0077d6;\n    --muted: #6b7280;\n\n    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;\n    line-height: 1.65;\n    margin: 24px;\n    padding: 32px;\n    background: linear-gradient(180deg, var(--primary-50), #f6fbff);\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(2,48,84,0.06);\n    color: #042a48;\n}\n.amazon-img{\n    max-width: 100%;\n    height: auto;\n    display:block;\n    margin: 12px 0;\n    border-radius: 8px;\n    box-shadow: 0 8px 20px rgba(2,48,84,0.04);\n}\n.amazon-title-headline{\n    font-size: 24px;\n    font-weight: 800;\n    color: var(--primary-500);\n}\n.amazon-sub-title-headline{\n    font-size: 18px;\n    font-weight: 700;\n    margin-top: 12px;\n}\n.amazon-list{\n    margin-left: 20px;\n}\n.amazon-outline-bullet{\n    margin-left: 20px;\n}\n.amazon-tips{\n    background: linear-gradient(90deg, rgba(3,90,166,0.06), rgba(0,119,214,0.04));\n    padding: 12px;\n    border-radius: 8px;\n    color: var(--muted);\n}\n.stv-table{ width:100%; border-collapse: collapse; background: #fff; border-radius:8px; overflow:hidden; }\n.stv-table th, .stv-table td{ border:1px solid #e6eefc; padding:12px; }\n.tdBold{ font-weight:700; }\n\n@media (max-width:900px){\n    .amazon-container{ padding:18px; margin:12px; }\n    .amazon-sub-title-headline{ font-size:16px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
